import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten3: "#A0D3B4",
          lighten2: "#51AD74",
          lighten1: "#318450",
          base: "#217b43",
          darken1: "#185830",
        },
        grey: {
          darken4: "#303030",
          darken3: "#555B63",
          lighten3: "#d9d9d9",
          lighten4: "#F4F8F6",
        },
        secondary: "#424242",
        accent: "#82B1FF",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
      },
    },
  },
  lang: {
    locales: { pt },
    current: "pt",
  },
  icons: {
    iconfont: "fa",
  },
});
